import jsClientDeviceIdentifier from './jsClientDeviceIdentifier';

window.Roblox.JsClientDeviceIdentifier = jsClientDeviceIdentifier;
